import { render, staticRenderFns } from "./KosgebModal.vue?vue&type=template&id=4e042bf4"
import script from "./KosgebModal.vue?vue&type=script&lang=js"
export * from "./KosgebModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports